import React, { useState } from 'react';
import { ButtonProps } from 'antd/lib/button';
import ConfirmActionButton from '@severalnines/bar-frontend-components/build/lib/General/ConfirmActionButton';
import CmonUsersService from '../../../services/cmon/CmonUsersService';
import { useDebugContext } from '../../../common/Debug';
import { notifyError } from '../../Notifications/uiNotification';
import CcUser from '../../../services/models/CcUser';

export default UserDeleteButton;

export type UserDeleteButtonProps = ButtonProps & {
    user: CcUser;
    onSuccess?: () => void;
    onError?: (error: any) => void;
};

function UserDeleteButton({
    user,
    children,
    onSuccess,
    onError,
    ...rest
}: UserDeleteButtonProps) {
    const { log } = useDebugContext();
    const [loading, setLoading] = useState(false);
    const handleClick = async () => {
        try {
            setLoading(true);
            await CmonUsersService.deleteUser({
                user: {
                    class_name: 'CmonUser',
                    user_name: user.userName,
                },
            });

            onSuccess?.();
        } catch (err) {
            log.error(err);
            notifyError({ content: err.message });
            onError?.(err);
        }
        setLoading(false);
    };

    return (
        <ConfirmActionButton
            confirmTitle={'Delete user?'}
            onConfirm={handleClick}
            loading={loading}
            critical={true}
            {...rest}
        >
            {children || 'Delete'}
        </ConfirmActionButton>
    );
}
